//* Adrop 광고 유닛 ID
//* 위치별 매핑은 docs/plans/2026-05-26-001-feat-adrop-ads-expansion-plan.md 참조
//* dev 환경에선 Adrop이 광고를 내려주지 않으므로 prod/dev 분기 없이 단일 상수로 사용한다.
//* 빈 string('') 키는 콘솔 ID 미발급 placeholder — useAd 호출처에서 falsy 가드로 null 반환.

import { IS_PRODUCT } from './env';

//* 운영 도메인이 아닌 모든 환경(로컬 + dev 배포)에서 광고 위치 확인용 placeholder 노출.
//* 운영 외 환경에선 Adrop이 광고를 안 내려주므로 useAd가 SDK 로드를 건너뛰고,
//* 각 슬롯은 "개발용 광고 영역" placeholder로 통일 노출한다.
export const AD_SLOT_DEBUG_PLACEHOLDER_ENABLED = !IS_PRODUCT;

export const AD_UNIT_IDS = {
  //* === 피드홈 (allowed)/(home) ===
  HOME_SIDE_P: '01KRJ2719R56VGG2JZYSXCVV4D', //* WEL_PC_홈_우 — PC 우측 사이드
  HOME_FEED_NATIVE_M: '01KRJ2719RFHTRFMT03P2D2JT1', //* WEL_MO_홈_목록_피드 — 모바일 피드 네이티브
  HOME_FEED_NATIVE_P: '01KRJ2719R4JRSXH3VKCQ198BP', //* WEL_PC_홈_목록_피드 — PC 피드 네이티브
  HOME_FEED_LIST_BANNER_M: '01KRJ2719RF34VX0Z4N2SCK764', //* WEL_MO_홈_목록_배너 — 모바일 피드 배너 (기존 01KQ6T9KZR 교체)
  HOME_FEED_LIST_BANNER_P: '01KRJ2719SXECHK5KXG9RX4G7M', //* WEL_PC_홈_목록_배너 — PC 피드 배너 (기존 01KQ6TCR4Y 교체)

  //* === 통합검색 + 카테고리별 검색 (allowed)/search ===
  SEARCH_TOP_M: '01KRJ2719SF8B9TSX8EDQKGT0K', //* WEL_MO_통합검색_상_배너
  SEARCH_TOP_P: '01KRJ2719SRQAYF4HTVZWCYM2S', //* WEL_PC_통합검색_상_배너
  SEARCH_SIDE_P: '01KRJ2719SM20J38BF8PSNGH1C', //* WEL_PC_통합검색_우_배너

  //* 통합검색 전체 탭 — 카테고리별 결과 슬롯
  SEARCH_ALL_POLICY_M: '01KRJ2719SSZSPQAY50ADR1RXB', //* WEL_MO_통합검색_정책_피드
  SEARCH_ALL_POLICY_P: '01KRJ2719S6WHJ93S3C4WG5N8J', //* WEL_PC_통합검색_정책_피드
  SEARCH_ALL_HOMETOWNS_M: '01KRJ2719TXJA8F2RMMSJEB961', //* WEL_MO_통합검색_동네소식_피드
  SEARCH_ALL_HOMETOWNS_P: '01KRJ2719TQSV327A04ADSE67Z', //* WEL_PC_통합검색_동네소식_피드
  SEARCH_ALL_POLICY_GUIDE_M: '01KRJ2719TZYNNTD6T7QH1KX1K', //* WEL_MO_통합검색_정책활용가이드_피드
  SEARCH_ALL_POLICY_GUIDE_P: '01KRJ2719T170V6QCT5RAHKBH2', //* WEL_PC_통합검색_정책활용가이드_피드

  //* 통합검색 전체 탭 — 콘솔 ID 미발급 (placeholder)
  SEARCH_ALL_FESTIVAL_M: '',
  SEARCH_ALL_FESTIVAL_P: '',
  SEARCH_ALL_DONATION_BUSINESS_M: '',
  SEARCH_ALL_DONATION_BUSINESS_P: '',

  //* 단일 카테고리 검색 결과
  SEARCH_POLICY_M: '01KRJ2719TN9M89FAFGBR5QNAD', //* WEL_MO_정책_피드
  SEARCH_POLICY_P: '01KRJ2719TPANFGFW5M2TYM3V4', //* WEL_PC_정책_피드
  SEARCH_HOMETOWNS_M: '01KRJ2719VZDYV5VMV0S85ETN5', //* WEL_MO_동네소식_피드
  SEARCH_HOMETOWNS_P: '01KRJ2719V7FCFXPCNX5WAA9QA', //* WEL_PC_동네소식_피드
  SEARCH_POLICY_GUIDE_M: '01KRJ2719VNDN4NHD1DX045NB1', //* WEL_MO_정책활용가이드_피드
  SEARCH_POLICY_GUIDE_P: '01KRJ2719VVKBYGRSDV9CK9SZ6', //* WEL_PC_정책활용가이드_피드
  SEARCH_GIFT_M: '01KRJ2719WCKAQ642576T2KSES', //* WEL_MO_답례품_피드
  SEARCH_GIFT_P: '01KRJ2719WEHH5XCAMKND8KMMB', //* WEL_PC_답례품_피드
  SEARCH_DONATION_BUSINESS_M: '01KRJ2719WB9F3QTXEWN5YR082', //* WEL_MO_지정기부사업_피드
  SEARCH_DONATION_BUSINESS_P: '01KRJ2719W1EFDCBWP61R9Y82Y', //* WEL_PC_지정기부사업_피드
  SEARCH_LOCAL_MARKET_M: '01KRJ2719WDSR97AJB3ZK9N7JM', //* WEL_MO_웰마켙_피드
  SEARCH_LOCAL_MARKET_P: '01KRJ2719XF70W3YGZBMAHME2H', //* WEL_PC_웰마켙_피드

  //* 축제 카테고리 — 콘솔 ID 미발급 (placeholder)
  SEARCH_FESTIVAL_M: '',
  SEARCH_FESTIVAL_P: '',

  //* === 정책활용가이드 상세 (allowed)/community/policyInfo/[id] ===
  POLICY_GUIDE_TOP_M: '01KRJ2719XGRVKGH8P80TT41RM', //* WEL_MO_정책활용가이드_상_배너
  POLICY_GUIDE_SIDE_P: '01KRJ2719XHPHMN2VWDVQT9A4P', //* WEL_PC_정책활용가이드_우_배너
  POLICY_GUIDE_BOTTOM_M: '01KRJ2719X33VW5Z6J13K2EKPG', //* WEL_MO_정책활용가이드_하_피드
  POLICY_GUIDE_BOTTOM_P: '01KRJ2719XF79F7WVF93D2HVD9', //* WEL_PC_정책활용가이드_하_피드

  //* === 정책소식/응급실 상세 본문 하단 ===
  //* TODO(plan U6): 신규 POLICY_GUIDE_BOTTOM_M/P와 위치 충돌 여부 PM 확인 후 통합 또는 분리
  CONTENT_DETAIL_BOTTOM_BANNER: '01KG20GCDANJS0YKTPET4WAVF9',

  //* === 마이페이지 — 콘솔 ID 미발급 (placeholder) ===
  MYPAGE_BOTTOM_M: '',
  MYPAGE_BOTTOM_P: '',
  MYPAGE_SIDE_P: '',
} as const;
